import { useEffect, useState } from 'react';

export const useNoticeHandler = () => {
  const [audioElement, setAudioElement] = useState<HTMLMediaElement>();

  const showNotification = () => {
    if (!audioElement) return;

    audioElement.currentTime = 0;

    audioElement.play().catch((error) => {
      if (error.name === 'NotAllowedError') {
        console.warn('播放失败：需要用户交互才能播放声音');
      } else {
        console.error('播放失败：', error);
      }
    });
  };

  useEffect(() => {
    // 创建并预加载音频元素
    const audio = new Audio('/media/tindeck.mp3');
    audio.preload = 'auto';
    audio.load();
    setAudioElement(audio);

    return () => {
      // 清理音频资源
      if (audioElement) {
        audioElement.pause();
        audioElement.src = '';
      }
    };
  }, []);

  return {
    showNotification,
  };
};
